import Header from '../components/header';
import '../css/index.scss';
import '../css/contact.scss';

new Header();

// ── Contact form logic ────────────────────────────────────────────────────────

const form    = document.getElementById('contactForm');
const submit  = document.getElementById('cfSubmit');
const error   = document.getElementById('cfError');

// Read by the success page to greet the sender by name
const NAME_KEY = 'onesight-contact-name';

if (form) {
    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        // ── Validate required fields ──────────────────────────────────────────
        const requiredInputs = form.querySelectorAll('[required]');
        let valid = true;

        requiredInputs.forEach(input => {
            const isBlank = !input.value.trim();
            input.classList.toggle('is-invalid', isBlank);
            if (isBlank) valid = false;
        });

        // Validate email format if provided
        const emailInput = form.querySelector('#cf-email');
        if (emailInput && emailInput.value.trim()) {
            const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
            emailInput.classList.toggle('is-invalid', !emailOk);
            if (!emailOk) valid = false;
        }

        if (!valid) return;

        // ── Clear previous status ─────────────────────────────────────────────
        error.classList.remove('is-visible');
        submit.disabled = true;
        submit.classList.add('is-loading');
        submit.textContent = '';

        // ── Gather fields ─────────────────────────────────────────────────────
        const getValue = (id) => (form.querySelector(`#${id}`)?.value.trim() || '');

        const payload = {
            type:          'contact',
            name:          getValue('cf-name'),
            mail:          getValue('cf-email'),
            company:       getValue('cf-company'),
            companySize:   getValue('cf-size'),
            sector:        getValue('cf-sector'),
            phone:         getValue('cf-phone'),
            subject:       getValue('cf-subject'),
            projectStatus: getValue('cf-status'),
            budget:        getValue('cf-budget'),
            timeline:      getValue('cf-timeline'),
            body:          getValue('cf-message'),
            page:          document.title,
        };

        // ── Submit ─────────────────────────────────────────────────────────────
        try {
            const res = await fetch('/.netlify/functions/submit', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (!res.ok || !data.success) throw new Error(data.message || 'Unknown error');

            try {
                sessionStorage.setItem(NAME_KEY, payload.name.split(/\s+/)[0]);
            } catch (err) {
                // Storage blocked: the success page falls back to a generic greeting
            }
            // Keep the button in its loading state while the next page loads
            window.location.assign('/contact-success/');
        } catch (err) {
            console.error('[contact form]', err);
            error.classList.add('is-visible');
            error.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            submit.disabled = false;
            submit.classList.remove('is-loading');
            submit.textContent = 'Send message';
        }
    });

    // Live clear invalid state on input
    form.addEventListener('input', (e) => {
        if (e.target.classList.contains('is-invalid') && e.target.value.trim()) {
            e.target.classList.remove('is-invalid');
        }
    });
}
